const createKey = (str: string) => `hyper-${str}`;

export const STORED_ATOM_KEYS = {
  DUEL_ENTRY: createKey("duel-entry"),
  DUEL_OPPONENT: createKey("duel-opponent"),
  ACTIVE_GAME_ID: createKey("active-game-id"),
  GAME_FLOW_STATE: createKey("game-flow-state"),
  GAME_TYPE: createKey("game-type"),
  PRACTICE_GAME_ENTRY: createKey("practice-game-entry"),
  ONBOARDING_STEP: createKey("onboarding-step"),
  GAME_SHARE_LINKS: createKey("game-share-links"),
  USER: createKey("user"),
  USER_PROFILE: createKey("user-profile"),
  USER_HAS_ALLOWED_LOCATION: createKey("user-has-allowed-location"),
  USER_HAS_SUBSCRIBED: createKey("user-has-subscribed"),
  USER_CUSTOM_AVATAR: createKey("user-custom_avatar"),
  TOPUP_INFO: createKey("topup-info"),
  PAYMENT_STATUS: createKey("payment-status"),
};
